/**
 * CompartmentPopover — cursor-following popover shown on compartment hover in InfoMode.
 *
 * Displays the compartment name and up to 7 data fields controlled by the `settings`
 * object built by the parent from panelSettings + capabilities.
 * This component is display-only — no CMS/capabilities logic lives here.
 */

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { buildCompartmentItems } from '../../utils/popoverItems.js'

import { BottomSheet } from '../../../../shared/ui/BottomSheet/BottomSheet.jsx'
import { DataGrid } from '../../../../shared/ui/DataGrid/index.js'

import { HoverPopoverCard }      from './HoverPopoverCard.jsx'

/**
 * @param {object}              props
 * @param {object|null}         props.compartment        — compartment data from product.compartments
 * @param {{x:number,y:number}} props.position           — seed cursor position for initial placement
 * @param {boolean}             props.isOpen             — controls Popover visibility
 * @param {function}            [props.onClose]          — called by Popover on Escape / scroll
 * @param {object}              [props.settings]         — computed display flags (see PlanRendererInfoMode)
 * @param {object|null}         [props.compartmentTypes] — raw compartments.json or its types map
 */
export function CompartmentPopover({ compartment, position, isMobile, isOpen, onClose, settings = {}, compartmentTypes = null }) {
  const { t } = useI18n()

  const header = compartment ? t(`compartments.${compartment.name_cad}`, compartment.name_cad) : ''
  const items  = compartment ? buildCompartmentItems(compartment, compartmentTypes, t, settings) : []

  if (isMobile) {
    return (
      <BottomSheet isOpen={isOpen} onClose={onClose}>
        <BottomSheet.Header closeLabel={t('product.popover_close')}>
          <span>{header}</span>
        </BottomSheet.Header>
        <BottomSheet.Content>
          {items.length > 0 && <DataGrid items={items} columns={4} size="small" />}
        </BottomSheet.Content>
      </BottomSheet>
    )
  }

  return (
    <HoverPopoverCard
      isOpen={isOpen}
      position={position}
      onClose={onClose}
      header={header}
      items={items}
    />
  )
}
